import { Box, styled, Typography } from '@mui/material';

export type OfferStatusSeverity = 'info' | 'success' | 'warning' | 'error';

export const SEVERITY_COLORS: Record<
  OfferStatusSeverity,
  { bg: string; border: string; icon: string }
> = {
  info: { bg: '#F0FAFF', border: '#B9E7FF', icon: '#0368A3' },
  success: { bg: '#F0FBF4', border: '#C2E4C3', icon: '#1A7A3C' },
  warning: { bg: '#FEF7EC', border: '#F0D19B', icon: '#F57C00' },
  error: { bg: '#FDF1EE', border: '#F7D6CC', icon: '#CC3300' },
};

export const BannerRoot = styled(Box, {
  shouldForwardProp: prop => prop !== '$severity',
})<{ $severity: OfferStatusSeverity }>(({ theme, $severity }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  padding: theme.spacing(1.5),
  borderRadius: 6,
  border: `1px solid ${SEVERITY_COLORS[$severity].border}`,
  backgroundColor: SEVERITY_COLORS[$severity].bg,
}));

export const BannerHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const BannerTitle = styled(Typography)(({ theme }) => ({
  fontSize: 13,
  fontWeight: 500,
  color: theme.palette.main.black,
}));

export const BannerRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1, 4),
  marginLeft: '26px',
}));

export const BannerBody = styled(Typography)({
  flex: '1 1 240px',
  minWidth: 0,
  fontSize: 14,
  fontWeight: 400,
  lineHeight: 1.5,
  color: '#808080',
});

export const BannerAction = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: theme.spacing(2, 3),
}));
